/// <amd-module name="Test/Analytics/TrendChartCommon/Types" />
import * as CommonTypes from "Test/Analytics/Common/Types";

export interface ITrendChartAggregateData {
    date: string;
    aggrValue: number;
}

export interface ITrendChartData extends CommonTypes.IReportData {
    primaryChartData: { [key: string]: ITrendChartAggregateData[] }; // This will be stackby to aggr data
    secondaryChartData?: ITrendChartAggregateData[];
    metricSelected?: CommonTypes.Metric;
}

export interface ITrendChartSource {
    queryTrendChartData(
        testReportContext: CommonTypes.ITestReportContext,
        confValues: CommonTypes.IReportConfiguration,
        chartMetric: CommonTypes.Metric
    ): Promise<ITrendChartData>;
}
